import {
  ExchangeIcon_default
} from "./chunk-VW4IWL6M.mjs";
export {
  ExchangeIcon_default as default
};
